<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.97 25.85">
    <defs>
    </defs>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <g id="Group_69" data-name="Group 69">
          <path
            id="Path_36"
            data-name="Path 36"
            class="cls-1"
            d="M22.9,4.15,14.61,0,7.15,3.32v7.46l8.29,4.14h0l7.46-3.31ZM14.59.86l6.9,3.38-6.5,3-1.92-.94L8.15,3.82ZM22.12,11.1l-6.63,3V7.94l6.63-3Z"
          />
          <path
            id="Path_37"
            data-name="Path 37"
            class="cls-1"
            d="M31,15.07l-8.29-4.15-7.47,3.32V21.7l8.29,4.15h0L31,22.53Zm-8.31-3.28,6.89,3.37-6.5,3-1.92-.94-4.92-2.46ZM30.19,22l-6.64,3V18.87l6.64-3Z"
          />
          <path
            id="Path_38"
            data-name="Path 38"
            class="cls-1"
            d="M15.75,14.42,7.46,10.27,0,13.59v7.46L8.29,25.2h0l7.46-3.32ZM7.44,11.14l6.89,3.37-6.5,3-1.92-.94L1,14.09ZM15,21.37l-6.63,3V18.21l6.63-3Z"
          />
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
